import { Sparkles, ShieldCheck, Search, CalendarClock, type LucideIcon } from "lucide-react";

export type ToolCategory = "documents" | "compliance" | "transactions";

export type Tool = {
  id: string;
  icon: LucideIcon;
  title: string;
  category: ToolCategory;
  categoryLabel: string;
  time: string;
  description: string;
  tags: string[];
  comingSoon?: boolean;
};

export const tools: Tool[] = [
  {
    id: "patricia",
    icon: Sparkles,
    title: "Patricia I",
    category: "documents",
    categoryLabel: "Documents",
    time: "~2-5 min",
    description:
      "One drafting agent for the core documents. Patricia produces affidavits with the prescribed oath and jurat, letters of demand with mora interest at the current prescribed rate (and the section 3 organ of state path), board, shareholder, written and special resolutions under the Companies Act, and NDAs through to shareholders agreements drafted or reviewed under the correct South African framework.",
    tags: ["Affidavit Drafting and Reviewing", "Letter of Demand", "Resolution Drafting and Reviewing", "Agreement Drafting and Reviewing"],
  },
  {
    id: "cp",
    icon: CalendarClock,
    title: "Conditions Precedent Tracker",
    category: "transactions",
    categoryLabel: "Transactions",
    time: "~3 min",
    description:
      "Upload the agreement. Casey extracts every condition precedent, computes each deadline by the method the agreement actually requires (court days, the statutory method, or the civil method), writes it to your calendar, and records the basis of every calculation for audit.",
    tags: ["CP extraction", "Deadline tracking", "Court days vs calendar days"],
    comingSoon: true,
  },
  {
    id: "dd",
    icon: Search,
    title: "Due Diligence",
    category: "transactions",
    categoryLabel: "Transactions",
    time: "~3 min",
    description:
      "A workspace per transaction. Casey generates the checklist for your deal type with the Companies Act, the Competition Act and sector regulation in frame, tracks responses, and returns a risk analysis ranked by materiality, stored against the transaction.",
    tags: ["M&A checklist", "Project finance", "Risk register"],
    comingSoon: true,
  },
  {
    id: "compliance",
    icon: ShieldCheck,
    title: "Compliance Agent",
    category: "compliance",
    categoryLabel: "Compliance",
    time: "Ongoing",
    description:
      "One register for every obligation: POPIA, FICA, B-BBEE, the Companies Act, Employment Equity, the Competition Act and the JSE Listings Requirements. Due dates tracked, checks run on schedule, and alerts raised before anything falls overdue.",
    tags: ["POPIA register", "FICA review", "Annual returns", "B-BBEE certificate"],
    comingSoon: true,
  },
];

export const filterCategories: { value: "all" | ToolCategory; label: string }[] = [
  { value: "all", label: "All tools" },
  { value: "documents", label: "Documents" },
  { value: "transactions", label: "Transactions" },
  { value: "compliance", label: "Compliance" },
];
